export default __webpack_public_path__ + "static/media/d3221286783904caf20301860cf065ce1575924577645.546e3517.webp";